import { useMutation } from '@apollo/client';

import { CreateTinderInput } from '../../apollo/__generated__/graphql';
import { CREATE_TINDER } from '../graphql/mutation/createTinderMutation.graphql';

export const useCreateTinderMutation = () => {
  const [mutate] = useMutation(CREATE_TINDER);

  const createTinder = (createTinderInput: CreateTinderInput) => {
    mutate({
      variables: {
        createTinderInput,
        eventId: createTinderInput.eventId,
      },
    });
  };

  return { createTinder };
};
